<template>
    <div class="section-notifications__payment-failure" :style="cssProps">
        <img src="@/assets/images/common/failure.png" alt="failure" />
        <div class="section-notifications__payment-failure__body">
            <h1 class="title t-transform-cap">
                {{ getTranslatedText("payment failure!!") }}
                {{ getTranslatedText(renderTitle()) }}
            </h1>
            <p class="description t-fir-transform-cap">
                {{
                    getTranslatedText(
                        "your payment has failed due to incorrect details. Check your details and try again"
                    )
                }}
            </p>
            <ButtonCustom
                type="primary"
                text="try again"
                @onClickButton="onClickMovePage"
            />
        </div>
    </div>
</template>
<script>
import "@/assets/scss/mobile/notification/_notification.scss";

import { isStrEmpty } from "@/components/common/utils";
import ButtonCustom from "@/components/common/button";

import languageMixin from "@/mixins/language/language-mixin";

export default {
    mixins: [languageMixin],
    components: {
        ButtonCustom,
    },
    data() {
        return {
            cssProps: {
                backgroundImage: `url(${require("@/assets/images/notify/background-notify.png")})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            },
            methodPayment: -1,
        };
    },
    created() {
        if (isStrEmpty(localStorage.getItem("methodPayment"))) {
            this.$router.push("/home");
        } else {
            this.methodPayment = parseInt(
                localStorage.getItem("methodPayment")
            );
            localStorage.removeItem("methodPayment");
        }
    },
    methods: {
        renderTitle() {
            return this.$route.query?.errors || ''
        },

        onClickMovePage() {
            if (this.methodPayment === 1) {
                this.$router.push("/wallet");
            } else {
                this.$router.push("/checkout");
            }
        },
    },
};
</script>
